"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ImageSwatch: function() {
        return _ImageSwatch.ImageSwatch;
    },
    imageSwatchClassNames: function() {
        return _useImageSwatchStylesstyles.imageSwatchClassNames;
    },
    renderImageSwatch_unstable: function() {
        return _renderImageSwatch.renderImageSwatch_unstable;
    },
    useImageSwatchStyles_unstable: function() {
        return _useImageSwatchStylesstyles.useImageSwatchStyles_unstable;
    },
    useImageSwatch_unstable: function() {
        return _useImageSwatch.useImageSwatch_unstable;
    }
});
const _ImageSwatch = require("./ImageSwatch");
const _renderImageSwatch = require("./renderImageSwatch");
const _useImageSwatch = require("./useImageSwatch");
const _useImageSwatchStylesstyles = require("./useImageSwatchStyles.styles");
